import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const BadgeBorder = styled.div``;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

export const BadgeTop = styled.div`
  width: 0;
  border-bottom: 25px solid ${ColorPalette.HEX.White};
  border-left: 43px solid ${ColorPalette.Transparent};
  border-right: 43px solid ${ColorPalette.Transparent};
`;

export const BadgeContent = styled.div`
  width: 86px;
  height: 48.5px;
  background-color: ${ColorPalette.HEX.White};
`;

export const BadgeBottom = styled.div`
  width: 0;
  border-top: 25px solid ${ColorPalette.HEX.White};
  border-left: 43px solid ${ColorPalette.Transparent};
  border-right: 43px solid ${ColorPalette.Transparent};
`;

export const BodyBadge = styled.div`
  position: absolute;
`;

export const BodyBadgeTop = styled.div`
  width: 0;
  border-bottom: 23px solid ${ColorPalette.HEX.ColumbiaBlue};
  border-left: 40px solid ${ColorPalette.Transparent};
  border-right: 40px solid ${ColorPalette.Transparent};
  margin-left: 3px;
  margin-top: 4px;
`;

export const BodyBadgeContent = styled.div`
  width: 80px;
  height: 45px;
  background-color: ${ColorPalette.HEX.ColumbiaBlue};
  margin-left: 3px;
`;

export const BodyBadgeBottom = styled.div`
  width: 0;
  border-top: 23px solid ${ColorPalette.HEX.ColumbiaBlue};
  border-left: 40px solid ${ColorPalette.Transparent};
  border-right: 40px solid ${ColorPalette.Transparent};
  margin-left: 3px;
`;

export const Title = styled.h1`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: -0.2px;
  text-align: center;
  color: ${ColorPalette.HEX.White};
`;

export const TitleContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 10px;
`;

export const DescriptionType = styled.label`
  padding: 0px;
  margin-right: 5px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.White};
`;

export const ImageContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    height: 100%;
    width: 100%;
  }
`;
export const DescriptionContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ImageType = styled.img`
  height: 80%;
`;

interface Props {
  initialColor: string;
  finalColor: string;
}

export const Container = styled.div<Props>`
  display: flex;
  width: 100%;
  height: 202px;
  border-radius: 16px;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  box-shadow: 0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1);
  background-image: ${(props: Props) => `linear-gradient(123deg, ${props.initialColor}, ${props.finalColor})`};
`;
